import { useMemo } from 'react';
import {
  cropLimitKeys,
  transformBase64ToFile,
} from '../../../components/DspxCropper';
import infoHeaderImgQuery from '../queries/infoHeaderImgQuery';
import UploadCoverContent from '../components/UploadCoverContent/UploadCoverContent';

const { useFetch: useCoverData } = infoHeaderImgQuery;

const limits = {
  [cropLimitKeys.minWidth]: 393,
  [cropLimitKeys.minHeight]: 224,
  [cropLimitKeys.maxSize]: 15728640,
};

const defaultExtension = 'jpg';

const transformData = (data) => {
  if (!data) return null;

  const { original, cropped, fileExtention, cropExtention, options } = data;
  const { zoom, ...otherOptions } = options || {};

  const fileExtension = fileExtention?.replace(/^\./, '') || defaultExtension;
  const cropExtension = cropExtention?.replace(/^\./, '') || defaultExtension;

  const file = transformBase64ToFile(original, `original.${fileExtension}`);
  const croppedFile = transformBase64ToFile(
    cropped,
    `cropped.${cropExtension}`
  );

  return {
    file,
    croppedFile,
    zoom,
    initialCroppedArea: otherOptions
      ? {
          ...otherOptions,
          x: otherOptions.xCoordinate,
          y: otherOptions.yCoordinate,
        }
      : null,
  };
};

export const useHeaderImgData = (infoId) => {
  const { data, isFetching } = useCoverData(infoId, {
    enabled: Boolean(infoId),
    staleTime: Infinity,
    notifyOnChangeProps: ['data', 'isFetching'],
  });

  const headerImgData = useMemo(() => transformData(data), [data]);

  const value = useMemo(
    () => ({
      data: headerImgData,
      isFetching,
      limits,
      aspect: 393 / 224,
      fileAccept: '.jpg, .jpeg',
      UploadCoverContent,
    }),
    [headerImgData, isFetching]
  );

  return value;
};
